export enum GdprFieldNames {
    GDPR_AGREE_SB_V1__info1_1 = "GDPR_AGREE_SB_V1__info1_1",

    GDPR_AGREE_SB_V1__info2_1 = "GDPR_AGREE_SB_V1__info2_1",
    GDPR_AGREE_SB_V1__info2_2 = "GDPR_AGREE_SB_V1__info2_2",
    GDPR_AGREE_SB_V1__info2_3 = "GDPR_AGREE_SB_V1__info2_3",
    GDPR_AGREE_SB_V1__info2_4 = "GDPR_AGREE_SB_V1__info2_4",
    GDPR_AGREE_SB_V1__info2_5 = "GDPR_AGREE_SB_V1__info2_5",
    GDPR_AGREE_SB_V1__info2_6 = "GDPR_AGREE_SB_V1__info2_6",

    GDPR_AGREE_SB_V1__info3_1 = "GDPR_AGREE_SB_V1__info3_1",
    GDPR_AGREE_SB_V1__info3_2 = "GDPR_AGREE_SB_V1__info3_2",
    GDPR_AGREE_SB_V1__info3_3 = "GDPR_AGREE_SB_V1__info3_3",
    GDPR_AGREE_SB_V1__info3_4 = "GDPR_AGREE_SB_V1__info3_4",
    GDPR_AGREE_SB_V1__info3_5 = "GDPR_AGREE_SB_V1__info3_5",

    GDPR_AGREE_SB_V1__info3_6 = "GDPR_AGREE_SB_V1__info3_6",
    GDPR_AGREE_SB_V1__info3_7 = "GDPR_AGREE_SB_V1__info3_7",
    GDPR_AGREE_SB_V1__info3_8 = "GDPR_AGREE_SB_V1__info3_8",
    GDPR_AGREE_SB_V1__info3_9 = "GDPR_AGREE_SB_V1__info3_9",
}
